export const theme = {
  primaryDark: '#1a233a',
  primaryLight: '#EFFFFA',
  primaryHover: '#343078',
  mobile: '576px',
};
